import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Handles the logic for a hover/click-activated dropdown menu.
 */
function initializeProductDropdown() {
    const productLinks = document.querySelectorAll<HTMLElement>('.nav-link-product');
    const productDropdown = document.querySelector<HTMLElement>('#nav-product-dropdown');

    if (!productDropdown || productLinks.length === 0) {
        return;
    }

    let hideTimeout: number;

    const showDropdown = () => {
        clearTimeout(hideTimeout);
        productDropdown.classList.remove('d-none');
        // Use requestAnimationFrame to ensure the 'd-none' class is removed before adding 'show'
        requestAnimationFrame(() => {
            productDropdown.classList.add('show');
        });
    };

    const startHideTimer = () => {
        hideTimeout = window.setTimeout(() => {
            productDropdown.classList.remove('show');
            // Listen for the transition to end before hiding it completely
            productDropdown.addEventListener('transitionend', () => {
                productDropdown.classList.add('d-none');
            }, { once: true });
        }, 300);
    };

    productLinks.forEach(productLink => {
        productLink.addEventListener('mouseenter', showDropdown);
        productLink.addEventListener('mouseleave', startHideTimer);
        productLink.addEventListener('click', e => {
            e.preventDefault();
            showDropdown();
        });
    });

    productDropdown.addEventListener('mouseenter', showDropdown);
    productDropdown.addEventListener('mouseleave', startHideTimer);
}

/**
 * Sets up a ResizeObserver to dynamically update the dropdown's position based on the header's height.
 */
function observeHeaderHeight() {
    const header = document.querySelector<HTMLElement>('header');
    const productDropdown = document.querySelector<HTMLElement>('#nav-product-dropdown');

    if (!header || !productDropdown) {
        return;
    }

    const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
            const height = (entry.target as HTMLElement).offsetHeight;
            productDropdown.style.setProperty('--header-height', `${height}px`);
        }
    });

    resizeObserver.observe(header);
}

/**
 * Initializes the Swiper instance for the mobile navigation.
 */
function initializeMobileNavSwiper() {
    const mobileNavSwiper = document.querySelector<HTMLElement>('#mobile-nav-products .swiper');

    if (mobileNavSwiper) {
        new Swiper(mobileNavSwiper, {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 32,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}

// Initialize all components when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', () => {
    initializeProductDropdown();
    observeHeaderHeight();
    initializeMobileNavSwiper();
});